import { TAppState } from '../../types/appState';
import { currentOpenChatSelector } from '../currentOpenChatSelector';

export const chatImagesSelector = (state: TAppState) => {
  const chat = currentOpenChatSelector(state);

  return chat?.images || null;
};
